// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"24f97587","239":"305c6e88","732":"2fa5e44e"}[chunkId] + ".chunk.js";
};